const TerrainModel = {
    terrain_read_model : {
        name: "",
        topography: {
            area: "",
            elevation: ""
        },
        address: {
            street: "",
            number: "",
            municipality: '',
            municipality_code: "",
            region: '',
            province: '',
            postal_code: "",
            country: ''
        },
        homogeneous_growing_area: '',
        coordinates: "",
        id: '',
        landlord_id: '',
        plots: [],
        report: {
            last_sent_datetime: "",
            frequency: "weekly",
            emails: [
            ""
            ]
        }
    },

    terrain_create_model : {
        name: "",
        topography: {
        area: "",
        elevation: ""
        },
        address: {
        street: "",
        number: "",
        municipality: '',
        municipality_code: "",
        region: '',
        province: '',
        postal_code: "",
        country: ''
        },
        homogeneous_growing_area: '',
        coordinates: "",
        id: '',
        landlord_id: '',
    },

    terrain_update_model : {
        name: "",
        landlord_id: "",
        topography: {
            area: 0,
            elevation: 0
        },
        address: {
            street: "",
            number: "",
            municipality: "",
            municipality_code: "",
            region: "",
            province: "",
            postal_code: "",
            country: ""
        },
        homogeneous_growing_area: "",
        coordinates: ""
    }
};

export default TerrainModel;